t = require('views/internal/teacup-with-helpers')('board_menu_default')

module.exports.renderInputRow = t.renderable ({ title, showFilterButton }) ->
  t.div '.board-menu-navigation-row', ->
    t.div '.input-container', ->
      t.input '.js-input.js-autofocus', {
        type: 'search',
        attr: 'title',
        placeholder: t.l('search-cards-placeholder'),
        'aria-label': t.l('search-cards-placeholder'),
        value: title
      }
      t.div '.js-input-search-icon'

    if showFilterButton
      t.button '.button.js-search-open-card-filter', ->
        t.icon 'filter'

module.exports.renderInputIcon = t.renderable ({ title }) ->
  if title
    t.a '.input-icon.js-search-clear-title', { href: '#' }, ->
      t.icon 'close'
  else
    t.a '.input-icon.js-search-open-card-filter', { href: '#' }, ->
      t.icon 'search'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_sidebar_search_input.coffee